module.exports = __webpack_public_path__ + "img/sitting_pretty.bb30cd6b.png";